// extracted by mini-css-extract-plugin
export default {"wrapper":"JvQfrQ","space":"vOVkvY","tab":"gCZ6eF","container":"zLaMGv"};